
import { defineComponent, toRef, watch, computed } from "vue";
import Text from "@/Components/Utilities/Text.vue";

interface Props {
  description: string;
}

export default defineComponent({
  components: {
    Text,
  },
  props: {
    description: {
      type: String,
      required: false,
      default: () => "",
    },
  },
  setup(props: Props) {
    return {};
  },
});
